import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import {
	DEFAULT_MEDIA_FILE_CONFIG,
	FileData,
	MediaFileConfig,
	MediaResponse
} from '@models/models';
import { RejectedFile } from 'ngx-dropzone/lib/ngx-dropzone.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { BrandDetailsActions } from '@models/brands.model';

@Component({
	selector: 'media-drop-zone',
	template: require('./media-drop-zone.component.html'),
	styles: [require('./media-drop-zone.component.scss')]
})
export class MediaDropZoneComponent implements OnInit, OnChanges {
	@Input() title: string;
	@Input() description: string;
	@Input() styles;
	@Input() inputFile: FileData;
	@Input() mediaConfig: Partial<MediaFileConfig>;
	@Input() actions: BrandDetailsActions;
	@Output()
	onDropEventSuccess: EventEmitter<MediaResponse> = new EventEmitter();
	@Output() onRemoveEvent: EventEmitter<string> = new EventEmitter();

	file: FileData;

	dropzoneConfig: Partial<MediaFileConfig>;

	constructor(private messageService: MessageService) {}

	ngOnInit(): void {
		this.dropzoneConfig = { ...DEFAULT_MEDIA_FILE_CONFIG, ...this.mediaConfig };
		if (this.inputFile) {
			this.file = this.inputFile;
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.inputFile && changes.inputFile.currentValue) {
			this.file = changes.inputFile.currentValue;
		}
	}

	onMediaSelect(ev): void {
		if (ev.rejectedFiles.length) {
			this.validateOnError(ev.rejectedFiles[0]);
		} else {
			this.convertFileToBase64(ev.addedFiles[0]);
		}
	}

	convertFileToBase64(file): void {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = (): void => {
			this.onDropEventSuccess.emit({
				id: this.mediaConfig.id,
				data: {
					name: file.name,
					contentType: file.type,
					size: file.size,
					base64: this.cutFrom('base64,', reader.result.toString())
				}
			});
		};
		reader.onerror = (error): void => {
			console.log('Error: ', error);
		};
	}

	cutFrom(searchValue: string, str: string): string {
		const commaIndex = str.indexOf(searchValue) + 7;
		return str.slice(commaIndex);
	}

	convertToBytes(megabyte): number {
		return megabyte * 1000 * 1000;
	}

	addImage(): void {
		document.getElementById(this.mediaConfig.id).click();
	}

	updateImage(): void {
		document.getElementById(this.mediaConfig.id).click();
	}

	removeImage(): void {
		this.file = null;
		this.onRemoveEvent.emit(this.mediaConfig.id);
	}

	private validateOnError(file: RejectedFile): void {
		if (file.reason === 'type') {
			this.messageService.showToaster('e_0', 'companyInformation');
		}

		if (file.reason === 'size') {
			this.messageService.showToaster(
				'e_1',
				'companyInformation',
				this.mediaConfig.maxFileSize.toString()
			);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/media-drop-zone/media-drop-zone.component.ts